import debounce from 'lodash/debounce';
import React, { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SearchInput } from '../input';

interface GlobalSearchTermInputProps {
    placeholder?: string;
    round?: boolean;
}

const SEARCH_KEY = 'search';

export const GlobalSearchTermInput = ({ placeholder = 'Search ...', round }: GlobalSearchTermInputProps) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState(searchParams.get(SEARCH_KEY) || '');

    const updateFilter = useMemo(
        () =>
            debounce((value: string) => {
                setSearchParams(
                    (urlSearchParams) => {
                        value ? urlSearchParams.set(SEARCH_KEY, value) : urlSearchParams.delete(SEARCH_KEY);
                        return urlSearchParams;
                    },
                    {
                        replace: true,
                    },
                );
            }, 500),
        [setSearchParams],
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        setSearchTerm(value);
        updateFilter(value);
    };

    return <SearchInput placeholder={placeholder} value={searchTerm} onChange={handleChange} round={round} />;
};
